import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.tc('温馨提示'),
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "flex-box"
  }, [_c('a-icon', {
    staticClass: "mr-10",
    staticStyle: {
      "color": "#FBB93B",
      "font-size": "20px",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "question-circle"
    }
  }), !_vm.timeoutStatus ? _c('p', {
    staticClass: "flex-item"
  }, [_vm._v(_vm._s(_vm.t('请在E签宝页面完成认证操作')))]) : _c('p', {
    staticClass: "flex-item"
  }, [_vm._v(_vm._s(_vm.t('实名认证超时, 请点击'))), _c('a', {
    attrs: {
      "data-permission": "welcome_poll_update_tip_reload",
      "id": "welcome_poll_update_tip_reload",
      "href": "javascript: window.location.reload()",
      "fbu-analyse-name": $t("\u5237\u65B0")
    }
  }, [_vm._v(_vm._s(_vm.t('刷新')))])])], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "welcome_poll_update_tip_undo",
      "id": "welcome_poll_update_tip_undo",
      "fbu-analyse-name": $t("\u672A\u5B8C\u6210\u8BA4\u8BC1")
    },
    on: {
      "click": _vm.handleCertification
    }
  }, [_vm._v(_vm._s(_vm.t('未完成认证')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "welcome_poll_update_tip_done",
      "id": "welcome_poll_update_tip_done",
      "fbu-analyse-name": $t("\u5DF2\u5B8C\u6210\u8BA4\u8BC1")
    },
    on: {
      "click": _vm.handleCertification
    }
  }, [_vm._v(_vm._s(_vm.t('已完成认证')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };